import { useState } from 'react'
import { Dispatch, SetStateAction } from 'react'
import LookupField from '../../components/wells/lookup-field'
import useUser from '../../hooks/use-user'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonsContainer, FormField, Heading, Modal } from '@msaf/core-react'

interface SelectRegionModalProps {
  modalIsOpen: boolean
  setModalIsOpen: Dispatch<SetStateAction<boolean>>
}
export default function SelectRegionModal({ modalIsOpen, setModalIsOpen }: SelectRegionModalProps) {
  const [selectedCouncil, setSelectedCouncil] = useState<string>()
  const [isInvalid, setIsInValid] = useState(false)
  const navigate = useNavigate()
  const { user } = useUser()

  const handleSelectCouncil = () => {
    if (!selectedCouncil) {
      setIsInValid(true)
    } else {
      // Navigate user to add a new well with state for selected council
      navigate('/wells/new/edit/setup', { state: { selectedCouncil } })
    }
  }

  return (
    <Modal
      onRequestClose={() => setModalIsOpen(false)}
      contentLabel='Select from the regions available to create a new well record'
      isOpen={modalIsOpen}
    >
      {/* TODO Styling of container for LookupField */}
      <Heading level={3}>Select Region</Heading>

      <FormField
        label='Choose a region to continue'
        labelId='selectARegionLabelId'
        validationMessages={isInvalid ? ['Please select a region to continue'] : []}
      >
        <LookupField
          isInvalid={isInvalid}
          isClearable={false}
          labelledBy='selectARegionLabelId'
          fieldId='listCouncils'
          value={`${user?.councilId} ?? ''`}
          setValue={({ value }) => setSelectedCouncil(value)}
          menuPortalTarget={null}
        />
      </FormField>
      <ButtonsContainer>
        <Button buttonStyle='text-action' label='Cancel' onClick={() => setModalIsOpen(false)} />
        <Button buttonStyle='primary' label='Select' onClick={handleSelectCouncil} />
      </ButtonsContainer>
    </Modal>
  )
}
